import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { PageWrapper, Loader, Alert, UserDetails } from '../../components';
import Actions, { thunks } from '../../redux/modules/users';
import { USER_TYPES } from '../../constants';
import { Link } from 'react-router-dom';

class Users extends React.Component {
    state = {
        userToDelete: null,
    };

    componentDidMount() {
        this.getUsers();
    }

    componentDidUpdate(prevProps) {
        const { match: { params: { userType } } } = this.props;
        if (userType !== prevProps.match.params.userType) this.getUsers();
    }

    getUsers = () => {
        const { dispatch, match: { params: { userType } }, updateProperty, history } = this.props;
        if (!USER_TYPES.find(type => type.value == userType)) history.push('/page-not-found');
        updateProperty('userType', userType)
        dispatch(thunks.getUsers());
    }

    viewUser = user => {
        const { dispatch, updateProperty } = this.props;
        updateProperty('showDetails', true)
        dispatch(thunks.getUserDetails(user.id));
    }

    deleteUser = (user) => {
        this.setState({ userToDelete: user })
    }

    handleDeleteBanner = () => {
        const { dispatch } = this.props;
        const { userToDelete } = this.state;
        dispatch(thunks.deleteUsers(userToDelete.id));
        this.setState({ userToDelete: null })

    }

    render() {
        const {
            list,
            loading,
            error,
            updateProperty,
            userType,
            loadingData,
            showDetails,
            data,
        } = this.props;
        const { userToDelete } = this.state;

        const type = userType == 1 ? 'Admin' : `Salesmen`
        return (
            <PageWrapper title={`${type} List`}>
                <Loader show={loading} />
                <Alert
                    show={!!error}
                    onHide={() => updateProperty('error', '')}
                    title={type}
                    message={error}
                />
                <div className="animated fadeIn">
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row mb-2">
                                        <div className="col-md-12 d-flex justify-content-end">
                                            <Link to={`/add-user/${userType}`}>
                                                <button className="btn btn-primary">Add</button>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>ID</th>
                                                    <th>Name</th>
                                                    <th>Phone</th>
                                                    <th />
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    list.length ? (
                                                        list.map(user => (
                                                            <tr key={user.id}>
                                                                <td>{user.id}</td>
                                                                <td>{user.name}</td>
                                                                <td>{'+' + user.countryCode + '-' + user.phoneNumber}</td>
                                                                <td>
                                                                    {userType != 1 && (
                                                                        <button title="View User" className="btn btn-xs btn-info" onClick={() => this.viewUser(user)}>
                                                                            <i className="fa fa-eye" />
                                                                        </button>
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {userType != 1 && (
                                                                        <button title="View User" className="btn btn-xs btn-danger" onClick={() => this.deleteUser(user)}>
                                                                            <i className="fa fa-trash" />
                                                                        </button>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" className="text-center">No Records Found</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <UserDetails
                    loading={loadingData}
                    data={data}
                    show={showDetails}
                    onHide={() => updateProperty('showDetails', false)}
                />
                 <Alert
                    show={!!userToDelete}
                    onHide={() => this.setState({ userToDelete: null })}
                    title="Delete User"
                    message={`Are you sure you want to delete User ID: ${(userToDelete || {}).id}?`}
                    onSubmit={this.handleDeleteBanner}
                />
            </PageWrapper>
        )
    }
}

const mapStateToProps = ({
    users: {
        loading,
        error,
        list,
        userType,
        loadingData,
        showDetails,
        data,
    },
}) => ({
    loading,
    error,
    list,
    userType,
    loadingData,
    showDetails,
    data,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
    reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(Users)